import React, { useMemo } from "react";
import clsx from "clsx";
import { useMediaQuery } from "react-responsive";
import { motion } from "framer-motion";

import { imgHero } from "../../assets/images";
import { mediaQueries } from "../../constant";
import styles from "./styles.module.scss";
import WordMasked from "../WordMasked";

const dataMasked = ["as Part of Your Lifestyle", "Incredible", "Enjoyable"];

export default function MainBanner() {
  // const isBiggerScreen = useMediaQuery({
  //   query: `(min-device-width: ${mediaQueries?.tablet}px)`,
  // });
  const variantContainer = useMemo(
    () => ({
      offScreen: { opacity: 0 },
      onScreen: {
        opacity: 1,
        transition: {
          when: "beforeChildren",
          staggerChildren: 0.3,
        },
      },
    }),
    []
  );
  const variantContent = useMemo(
    () => ({
      offScreen: { x: -50, opacity: 0 },
      onScreen: {
        x: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1.5,
        },
      },
    }),
    []
  );

  const variantImg = useMemo(
    () => ({
      offScreen: { x: 50, opacity: 0 },
      onScreen: {
        x: 0,
        opacity: 1,
        transition: {
          type: "spring",
          bounce: 0.4,
          duration: 1.5,
        },
      },
    }),
    []
  );

  return (
    <div className={clsx(styles.mainBanner)}>
      <motion.div
        variants={variantContainer}
        initial="offScreen"
        whileInView="onScreen"
        // viewport={{ once: true }}
        className={clsx(
          "flex flex-wrap items-center justify-between overflow-hidden",
          styles.container
        )}
      >
        <motion.div
          variants={variantImg}
          className={clsx(
            "-m-4 md:-m-8 lg:m-0 w-screen relative lg:w-1/2 lg:order-2",
            styles.imageContainer,
            styles.isImageCover
          )}
        >
          <div
            style={{ backgroundImage: `url('${imgHero}')` }}
            className={styles.imgHero}
          />
        </motion.div>
        <motion.div
          variants={variantImg}
          className={clsx(
            "-m-4 md:-m-8 lg:m-0 w-screen relative lg:w-1/2 lg:order-2",
            styles.imageContainer,
            styles.isImageContent
          )}
        >
          <img src={imgHero} alt="Make Housework" className={styles.imgHero} />
        </motion.div>
        <div
          className={clsx(
            "pr-8 mt-12 md:mt-16 lg:m-0 w-full lg:w-1/2 lg:order-1",
            styles.contentContainer
          )}
        >
          <motion.h1
            variants={variantContent}
            className={clsx("headline-remo text-4xl md:text-5xl")}
          >
            Be a <span className={styles.textYellow}>Chef</span>{" "}
            <span className="block" />
            For Your Home
          </motion.h1>
          {/* <motion.div variants={variantContent} classame="mt-2">
            <WordMasked
              data={dataMasked}
              classCustom={clsx(
                "font-bold text-4xl md:text-5xl",
                styles.textYellow
              )}
            />
          </motion.div> */}
          <motion.p
            variants={variantContent}
            className={clsx(
              "mt-2 lg:mt-8 text-base text-justify lg:text-xl w-10/12 lg:w-full"
            )}
          >
            Oxone tidak hanya sebagai produk yang mengutamakan efisiensi dalam
            bekerja, tetapi juga sebagai produk yang terus berkembang membantu
            dalam kebutuhan rumah tangga baik untuk membantu serta meningkatkan
            mutu hidup melalui mutu produk yang telah dipercaya oleh konsumen
            setia Oxone.
          </motion.p>
        </div>
      </motion.div>
    </div>
  );
}
